export const LOOKUP_IDS = {
  HinhThucXuLyCTNH: 'HinhThucXuLyCTNH',
  LoaiFileDinhKemCTNH: 'LoaiFileDinhKemCTNH',
};



// WEBPACK FOOTER //
// ./src/constants/lookup-list.js